import Mustache from '../vendor/mustache/mustache.min.js?_=3.8410.146.65';

function getPartials() {
	const partials = {};
	document.querySelectorAll('script[type="text/x-tmpl-mustache-partial"]').forEach(script => {
		const name = script.id.replace(/^partial-/, '');
		const inhalt = script.innerHTML;
		partials[name] = inhalt;
	});
	return partials;
}

/**
 * @param {string} containerId ID des HTML Elements, dessen Inhalt ersetzt werden soll
 * @param {any} data Daten für das Template
 * @param {string} [abweichendeTemplateId=null] abweichende Template-Id
 * @returns {void}
 */
export function render(containerId, data, abweichendeTemplateId = null) {
	const templateId = abweichendeTemplateId || `tmpl-${containerId}`;
	const script = document.querySelector(`script[type="text/x-tmpl-mustache"][id="${templateId}"]`);
	if (!script) {
		throw new Error(`Kein Script mit ID ${templateId} gefunden!`);
	}
	const template = script.innerHTML;
	if (!template) {
		throw new Error(`Template mit ID ${templateId} ist leer!`);
	}
	document.getElementById(containerId).innerHTML = Mustache.render(template, data, getPartials());
}

window.mustacheHelper = { render };
